module.exports = __webpack_public_path__ + "static/img/group@3x.1a98730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding/group@3x.jpg
// module id = yTt3
// module chunks = 6